<template>
    <div class="tax-calculator sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>计算个税</el-breadcrumb-item>
            <el-breadcrumb-item>个税计算器</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="content-box">
            <div class="table-caption">
                <div class="caption">收入录入</div>
                <div class="handler">
                    <el-button size="small" @click="addEntry">添加人员</el-button>
                    <el-button type="primary" size="small" @click="openQuickFill">一键录入</el-button>
                </div>
            </div>
            <el-table
                class="income-table"
                :data="entries"
                border
                stripe
                :header-cell-style="headerStyle"
                :cell-style="cellStyle"
                size="small">
                <el-table-column
                    width="140"
                    label="人员">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.name"
                            size="small"
                            placeholder="请输入人员名称" />
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="month in months"
                    :key="month.value"
                    :label="month.label"
                    :min-width="130"
                    align="center">
                    <template slot-scope="scope">
                        <el-input
                            :value="scope.row.months[month.value]"
                            size="small"
                            placeholder="请输入金额"
                            clearable
                            @input="value => handleAmountInput(scope.row, month.value, value)" />
                    </template>
                </el-table-column>
                <el-table-column
                    width="100"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            :disabled="entries.length === 1"
                            @click="removeEntry(scope.$index, scope.row)">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="action-box">
            <el-button
                size="small"
                @click="resetForm">
                重置
            </el-button>
            <el-button
                type="primary"
                size="small"
                :loading="loading"
                @click="handleCalculate">
                计算
            </el-button>
        </div>

        <div
            v-if="results.length"
            class="content-box">
            <div class="table-caption">
                <div class="caption">计算结果</div>
            </div>
            <div class="result-list">
                <el-card
                    v-for="item in results"
                    :key="item.id"
                    class="result-card"
                    shadow="never">
                    <div
                        slot="header"
                        class="card-header">
                        <div class="card-info">
                            <span class="card-title">{{ item.name }}</span>
                            <span class="card-subtitle">有效月份：{{ item.count }}</span>
                        </div>
                        <el-button
                            class="collapse-btn"
                            type="text"
                            size="small"
                            @click.stop="toggleResultCollapse(item)">
                            {{ item.collapsed ? '展开' : '折叠' }}
                        </el-button>
                    </div>
                    <el-table
                        v-show="!item.collapsed"
                        :data="item.listData"
                        border
                        stripe
                        size="small">
                        <el-table-column prop="name" label="月份" align="center" min-width="80" />
                        <el-table-column prop="money" label="当月收入" align="center" min-width="120" />
                        <el-table-column prop="total_money" label="累计收入" align="center" min-width="120" />
                        <el-table-column prop="diff_money" label="大额服务费" align="center" min-width="120" />
                        <el-table-column prop="tax_amount" label="累计应纳税额" align="center" min-width="140" />
                        <el-table-column prop="tax" label="本期个税" align="center" min-width="120" />
                        <el-table-column prop="tax_rate" label="本期税率" align="center" min-width="120" />
                        <el-table-column prop="scale" label="速算扣除数" align="center" min-width="140" />
                        <el-table-column prop="real_rate" label="实际税率" align="center" min-width="120" />
                        <el-table-column prop="real_money" label="本期税后收入" align="center" min-width="150" />
                    </el-table>
                </el-card>
            </div>
        </div>

        <el-dialog
            title="一键录入"
            :visible.sync="quickFillDialog.visible"
            width="360px"
            @close="handleQuickFillClose">
            <el-form
                class="quick-fill-form"
                :model="quickFillDialog.form"
                label-width="96px"
                size="small">
                <el-form-item label="录入人员">
                    <el-select
                        class="dialog-field"
                        v-model="quickFillDialog.form.entryId"
                        placeholder="请选择人员">
                        <el-option
                            v-for="item in entries"
                            :key="item.id"
                            :label="item.name || '未命名人员'"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="每月收入">
                    <el-input
                        class="dialog-field"
                        v-model="quickFillDialog.form.amount"
                        placeholder="请输入金额" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="quickFillDialog.visible = false">取消</el-button>
                <el-button
                    type="primary"
                    size="small"
                    @click="confirmQuickFill">
                    确定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const MONTHS = Array.from({ length: 12 }, (_, index) => {
    const month = index + 1
    return {
        label: `${month}月`,
        value: `month${month}`
    }
})

function createEntry (index) {
    const months = {}
    MONTHS.forEach(month => {
        months[month.value] = ''
    })
    return {
        id: `${Date.now()}_${index}`,
        name: `人员${index}`,
        months
    }
}

export default {
    name: 'TaxCalculator',
    data () {
        return {
            months: MONTHS,
            entries: [createEntry(1)],
            loading: false,
            results: [],
            quickFillDialog: {
                visible: false,
                form: {
                    entryId: '',
                    amount: ''
                }
            }
        }
    },
    methods: {
        headerStyle () {
            return {
                background: '#f5f7fa',
                color: '#303133',
                fontWeight: 500
            }
        },
        cellStyle () {
            return {
                padding: '8px 12px'
            }
        },
        addEntry () {
            const nextIndex = this.entries.length + 1
            this.entries.push(createEntry(nextIndex))
        },
        removeEntry (index, entry) {
            if (this.entries.length === 1) {
                return
            }
            this.entries.splice(index, 1)
            this.entries.forEach((item, idx) => {
                if (!item.name || /^人员\d+$/.test(item.name)) {
                    item.name = `人员${idx + 1}`
                }
            })
            this.results = this.results.filter(result => result.id !== entry.id)
        },
        resetForm () {
            this.entries = [createEntry(1)]
            this.results = []
        },
        handleAmountInput (entry, monthKey, value) {
            entry.months[monthKey] = this.formatAmount(value)
        },
        isEntryEmpty (entry) {
            return this.months.every(month => !entry.months[month.value])
        },
        buildPayload (entry) {
            const payload = {}
            this.months.forEach(month => {
                const value = entry.months[month.value]
                payload[month.value] = value ? value.trim() : ''
            })
            return payload
        },
        async handleCalculate () {
            const targets = this.entries.filter(entry => !this.isEntryEmpty(entry))
            if (!targets.length) {
                this.$message.warning('请先填写至少一个月的收入')
                return
            }
            this.loading = true
            try {
                const prevState = new Map(this.results.map(item => [item.id, item.collapsed]))
                const responses = await Promise.all(
                    targets.map(entry => {
                        return this.$http.post('/api/user/taxinput', this.buildPayload(entry))
                            .then(res => ({ entry, res }))
                            .catch(() => ({ entry, res: null }))
                    })
                )
                const resultList = []
                responses.forEach(({ entry, res }) => {
                    if (!res) {
                        this.$message.error(`${entry.name}计算失败，请稍后再试`)
                        return
                    }
                    if (res.code !== 0) {
                        this.$message.error(res.message || `${entry.name}计算失败`)
                        return
                    }
                    const data = res.data || {}
                    resultList.push({
                        id: entry.id,
                        name: entry.name,
                        listData: Array.isArray(data.listData) ? data.listData : [],
                        count: data.count || 0,
                        collapsed: prevState.get(entry.id) || false
                    })
                })
                this.results = resultList
                if (!resultList.length) {
                    this.$message.warning('未获得有效的计算结果')
                }
            } catch (err) {
                this.$message.error('计算失败，请稍后再试')
            } finally {
                this.loading = false
            }
        },
        formatAmount (value) {
            if (typeof value !== 'string') {
                value = value === null || value === undefined ? '' : String(value)
            }
            let formatted = value.replace(/[^\d.]/g, '')
            formatted = formatted.replace(/^\./, '')
            const parts = formatted.split('.')
            if (parts.length > 1) {
                formatted = `${parts[0]}.${parts.slice(1).join('')}`
            }
            const match = formatted.match(/^(\d+)(\.\d{0,2})?/)
            return match ? match[0] : formatted
        },
        openQuickFill () {
            if (!this.entries.length) {
                this.$message.warning('暂无可录入的人员')
                return
            }
            this.quickFillDialog.form.entryId = this.entries[0].id
            this.quickFillDialog.form.amount = ''
            this.quickFillDialog.visible = true
        },
        handleQuickFillClose () {
            this.quickFillDialog.form.entryId = ''
            this.quickFillDialog.form.amount = ''
        },
        confirmQuickFill () {
            const { entryId, amount } = this.quickFillDialog.form
            if (!entryId) {
                this.$message.warning('请选择需要录入的人员')
                return
            }
            const formattedAmount = this.formatAmount(amount)
            if (!formattedAmount) {
                this.$message.warning('请输入有效的金额')
                return
            }
            const target = this.entries.find(item => item.id === entryId)
            if (!target) {
                this.$message.error('未找到对应人员，请刷新后重试')
                return
            }
            this.months.forEach(month => {
                target.months[month.value] = formattedAmount
            })
            this.quickFillDialog.visible = false
            this.$message.success('录入成功')
        },
        toggleResultCollapse (item) {
            item.collapsed = !item.collapsed
        }
    }
}
</script>

<style scoped lang="scss">
.tax-calculator {
    padding: 0 20px 20px;

    .el-breadcrumb {
        margin-bottom: 16px;
    }

    .content-box {
        background: #fff;
        padding: 20px 24px;
        border-radius: 4px;
        margin-bottom: 20px;
        box-shadow: 0 2px 6px rgba(31, 49, 108, 0.05);
    }

    .table-caption {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .caption {
            font-size: 16px;
            font-weight: 500;
            color: #303133;
        }

        .handler {
            .el-button + .el-button {
                margin-left: 8px;
            }
        }
    }

    .income-table {
        width: 100%;

        ::v-deep .el-table__body-wrapper {
            overflow-x: auto;
            overflow-y: hidden;
            border-bottom: 1px solid #ebeef5;
            scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
        }

        ::v-deep .el-table::before,
        ::v-deep .el-table::after {
            background: transparent;
        }

        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.25);
            border-radius: 3px;
            margin: 0 16px;
        }

        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.35);
        }

        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track-piece:start,
        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track-piece:end {
            margin: 0;
        }

        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-button:horizontal:increment,
        ::v-deep .el-table__body-wrapper::-webkit-scrollbar-button:horizontal:decrement {
            width: 0;
            display: none;
        }

        ::v-deep .el-table__fixed,
        ::v-deep .el-table__fixed-right {
            height: calc(100% - 6px);
            bottom: 6px;
            overflow: hidden;
            z-index: 5;
        }

        ::v-deep .el-table__fixed-body-wrapper {
            bottom: 6px;
        }

        ::v-deep .el-table__fixed::before,
        ::v-deep .el-table__fixed-right::before {
            bottom: 6px;
        }
    }

    .action-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .el-button {
            min-width: 96px;
        }

        .el-button + .el-button {
            margin-left: 12px;
        }
    }

    .result-list {
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 16px;
    }

    .result-card {
        ::v-deep .el-card__header {
            display: flex;
            align-items: center;
            padding: 14px 20px;
            background: #f7f9fc;
        }

        .card-header {
            display: flex;
            align-items: center;
            width: 100%;

            .card-info {
                display: flex;
                align-items: baseline;
                gap: 12px;
            }

            .collapse-btn {
                margin-left: auto;
                padding: 0;
                background: transparent;
                border: none;
            }
        }

        .card-title {
            font-size: 14px;
            font-weight: 500;
            color: #303133;
        }

        .card-subtitle {
            font-size: 12px;
            color: #909399;
        }

        ::v-deep .el-card__body {
            padding: 0;
        }

        ::v-deep .el-table {
            width: 100%;
        }
    }

    .quick-fill-form {
        width: 100%;

        .dialog-field {
            width: 100%;
        }
    }
}
</style>
